<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <list
          @form="newTournament()"
          @view="modal = true"
          @clear="$refs.form.clear()"
        />

        <tournament-view
          :modal="modal"
          @edit="modalForm = true"
          @close="closeView"
        />
        <form-manager ref="form" :modal="modalForm" @close="closeForm" />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import FormManager from './FormManager'
import List from './List'
import TournamentView from '@/components/apps/tournaments/TournamentView'

export default {
  name: 'Tournaments',
  components: {
    List,
    FormManager,
    TournamentView,
  },
  data() {
    return {
      modal: false,
      modalForm: false,
      modalInscription: false,
    }
  },
  watch: {
    'filters.match': {
      handler: function (/* val, oldVal */) {
        if (this.localPagination.page !== 1) this.localPagination.page = 1
        this.debounceFetch('tournaments')
      },
    },
    statusOfButton: function (val) {
      if (val) {
        this.initData().finally(() => {
          this.setStatus(false)
        })
      }
    },
  },
  mounted() {
    this.initData()
  },
  computed: {
    ...mapState({
      filters: (state) => state.tournaments.filters,
      pagination: (state) => state.tournaments.pagination,
      statusOfButton: (state) => state.events.status,
    }),
    ...mapGetters({
      formatedList: 'tournaments/formatedList',
    }),

    localFilters: {
      get() {
        return this.filters
      },
      set(value) {
        this.$store.commit('tournaments/setFilters', value)
      },
    },
    localPagination: {
      get() {
        return this.pagination
      },
      set(value) {
        this.$store.commit('tournaments/setPagination', value)
      },
    },
    totalPages() {
      const { totalItems, rowsPerPage } = this.localPagination
      if (rowsPerPage) {
        return Math.ceil(totalItems / rowsPerPage)
      } else return 1
    },
  },
  methods: {
    ...mapActions({
      fetchTournaments: 'tournaments/fetchList',
      setStatus: 'events/setStatus',
    }),
    newTournament() {
      if (this.$refs.form) this.$refs.form.clear()
      this.modalForm = true
    },
    closeView() {
      if (this.$refs.form) this.$refs.form.clear()
      this.modal = false
      this.modalForm = false
    },
    closeForm() {
      if (!this.modal && this.$refs.form) this.$refs.form.clear()
      this.modalForm = false
    },
    changePage() {
      this.debounceFetch('tournaments')
    },
    async initData() {
      // this.resetPagitations()
      await Promise.all([this.fetchTournaments()])
    },
  },
}
</script>

<style scoped>
.mt-45 {
  margin-top: -45px;
}

.mt-56 {
  margin-top: -56px;
}

.title-tournament {
  text-shadow: 1px 1px #000;
  color: #62c6c5;
}

.tag-inscription {
  background-color: #6273b7;
}

.tag-end {
  background-color: red;
}

.tag-completed {
  background-color: #ffc107;
}
</style>
}
